import type ServerUrlsDataService from './server-urls.data-service';
import type ModalConversationService from './modal-conversation.service';
import type WalkerService from '../services/walker.service';
import type {LoginListener} from '../../login/login.service';
import {isEmptyObject} from 'shared/utils/custom-utils';


export class CatalogueSelectionLoginListener implements LoginListener {

    public static readonly serviceName = 'catalogueSelectionLoginListener';

    /*@ngInject*/
    constructor(private serverUrlsDataService: ServerUrlsDataService, private modalConversationService: ModalConversationService, private walker: WalkerService) {
    }

    public async update(): Promise<void> {
        const departmentsByUrls = await this.serverUrlsDataService.getDepartmentUrl();
        if (!isEmptyObject(departmentsByUrls)) {
            try {
                const catalogueUrl = await this.modalConversationService.openModalWindowAndGetPayload<string>('catalogueSelection', departmentsByUrls, {isComponent: true});
                this.walker.newPage(catalogueUrl);

                // get time to redirect
                return new Promise((resolve) => setTimeout(resolve, 2000));
            } catch (e) {
                //
            }
        }
    }
}